import { authClient, API } from "../index";

export const getCursoIntereses = () => {
  return authClient().get(`${API}/curso-interes?getDisabled=true`);
};

export const countCursoIntereses = () => {
  return authClient().get(`${API}/curso-interes/count`);
};

export const deleteCursoInteres = (id) => {
  return authClient().delete(`${API}/curso-interes/${id}`);
};

